import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { IWifiResponse } from './../model/types'

export const fetchWiFiData = async (id: number) => {
  const res: AxiosResponse<IWifiResponse> = await api.get(`shop/${id}/wifi`)
  return res.data.result
}
